// extracted by mini-css-extract-plugin
export default {"parameter":"Zxhug","hasPopup":"iu_2I","name":"Usdia","note":"sVLKm"};